var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"post-preview search-preview"},[_c('div',{staticClass:"search-item-preview"},[_c('div',{staticClass:"author"},[_vm._v("• "+_vm._s(_vm.advert.author))]),_c('div',{staticClass:"stitle"},[_vm._v(_vm._s(_vm.advert.title))]),_c('div',{staticClass:"tagline"},[_vm._v(_vm._s(_vm.advert.tagline))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }